import * as React from 'react'

const SvgMyReportIcon = ({ stroke }) => (
  <svg
    width="22"
    height="23"
    viewBox="0 0 22 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11 1.3999C12.3132 1.3999 13.6136 1.65856 14.8268 2.16111C16.0401 2.66366 17.1425 3.40025 18.0711 4.32884C18.9997 5.25742 19.7363 6.35982 20.2388 7.57307C20.7413 8.78633 21 10.0867 21 11.3999M11 1.3999V11.3999M11 1.3999C5.47715 1.3999 1 5.87705 1 11.3999C1 16.9227 5.47715 21.3999 11 21.3999C16.5228 21.3999 21 16.9228 21 11.3999M11 1.3999C16.5228 1.3999 21 5.87706 21 11.3999M21 11.3999L11 11.3999M21 11.3999C21 12.978 20.6265 14.5337 19.9101 15.9398C19.1936 17.3459 18.1546 18.5625 16.8779 19.4901L11 11.3999"
      stroke={stroke ? stroke : '#A4BCFD'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default SvgMyReportIcon
